import React from "react";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";

const CENTER_ICONS = ["hexagon", "star", "moon", "octagon", "triangle", "aperture"];

export function CrystalVisual({ name, imageUrl, seed = 0, height = 150, compact = false, showName = true }) {
  const { colors } = useTheme();

  if (imageUrl) {
    return (
      <div style={{ width: "100%", height, borderRadius: 16, overflow: "hidden", position: "relative", background: colors.surfaceTertiary }}>
        <img src={imageUrl} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        {showName ? (
          <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: "10px 12px", background: "rgba(45,42,43,0.45)" }}>
            <div style={{ color: "#FDFBF7", fontSize: 16, fontFamily: fonts.display, fontWeight: 700 }}>{name}</div>
          </div>
        ) : null}
      </div>
    );
  }

  const palettes = [
    [colors.brand, colors.brandSecondary],
    [colors.brandSecondary, colors.brandTertiary],
    [colors.brand, colors.brandPrimary],
    [colors.brandTertiary, colors.brandSecondary],
    [colors.brandSecondary, colors.brand],
    [colors.brandPrimary, colors.brandSecondary],
  ];
  const idx = ((seed % palettes.length) + palettes.length) % palettes.length;
  const [a, b] = palettes[idx];
  const centerIcon = CENTER_ICONS[idx];
  const lightBg = idx === 1 || idx === 3;
  const ink = lightBg ? colors.brand : colors.onBrand;

  const deco = (name, size, pos, opacity) => (
    <Icon name={name} size={size} color={ink} style={{ position: "absolute", opacity, ...pos }} />
  );

  return (
    <div
      style={{
        width: "100%",
        height,
        borderRadius: 16,
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        background: `linear-gradient(135deg, ${a}, ${b})`,
      }}
    >
      {deco("star", 14, { top: 12, left: 16 }, 0.35)}
      {deco("star", 9, { top: 28, left: 40 }, 0.22)}
      {deco("moon", 16, { top: 14, right: 18 }, 0.3)}
      {deco("star", 11, { bottom: 14, right: 24 }, 0.28)}
      {deco("star", 8, { bottom: 30, left: 22 }, 0.2)}
      <Icon name={centerIcon} size={compact ? 34 : 46} color={ink} style={{ opacity: 0.9 }} />
      {showName ? (
        <div
          style={{
            color: ink,
            fontSize: compact ? 14 : 18,
            fontFamily: fonts.display,
            fontWeight: 700,
            textAlign: "center",
            padding: "0 12px",
          }}
        >
          {name}
        </div>
      ) : null}
    </div>
  );
}
